import { inject, Injectable } from '@angular/core';
import { HttpGetNotificacoes } from './notificacoes.type';
import { HttpClient } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { BaseService } from 'src/app/services/base.service';

const API_URL = environment.apice.url;

@Injectable({
  providedIn: 'root'
})
export class NotificacoesServiceService {

  private http = inject(HttpClient);
  private BS = inject(BaseService);

  public closeMenu$ = new Subject<void>();

  public buscaTodasNotificacoes = (): Observable<HttpGetNotificacoes> => {
    return this.http.get<HttpGetNotificacoes>(API_URL + 'notificacoes/busca-notificacoes', this.BS.getHeaders(true));
  }

  public get tiposNotificacao(): {[key: number]: {txt: string, icon: string}} {
    return {
      1: {
        txt: "Mensagem",
        icon: 'email-outline'
      },
      2: {
        txt: "Atualização",
        icon: 'update'
      },
      3: {
        txt: "Alerta",
        icon: 'comment-alert-outline'
      },
      4: {
        txt: "Novidades",
        icon: 'newspaper-variant-outline'
      },
      5: {
        txt: "Tarefa",
        icon: 'menu-tarefas'
      }
    }
  }
}
